import PropTypes from 'prop-types';
// @mui
import { Checkbox, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

TableSelectedAction.propTypes = {
  sx: PropTypes.object,
  dense: PropTypes.bool,
  action: PropTypes.node,
  rowCount: PropTypes.number,
  numSelected: PropTypes.number,
  onSelectAllRows: PropTypes.func,
  label: PropTypes.node,
};

export default function TableSelectedAction({
  dense,
  action,
  rowCount,
  numSelected,
  onSelectAllRows,
  label,
  sx,
  ...other
}) {
  if (!numSelected) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        pl: 1,
        pr: 2,
        top: 0,
        left: 0,
        width: 1,
        zIndex: 9,
        height: 58,
        position: 'absolute',
        // No escuro o `primary.lighter` é um verde-água claro que destoa da página. A barra cobre
        // o cabeçalho da tabela, então o tom da seleção vai por cima do papel, e não transparente.
        bgcolor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.primary.lighter
            : theme.palette.background.paper,
        backgroundImage: (theme) =>
          theme.palette.mode === 'light'
            ? 'none'
            : `linear-gradient(${alpha(theme.palette.primary.main, 0.16)}, ${alpha(
                theme.palette.primary.main,
                0.16
              )})`,
        // O `primary.main` some nesse fundo escuro: o texto e os botões contornados da barra vão
        // no tom claro da primária, que ainda lê como a cor da marca.
        '& .MuiButton-outlinedPrimary': (theme) =>
          theme.palette.mode === 'light'
            ? {}
            : {
                color: theme.palette.primary.light,
                borderColor: alpha(theme.palette.primary.light, 0.5),
              },
        ...(dense && {
          height: 38,
        }),
        ...sx,
      }}
      {...other}
    >
      <Checkbox
        indeterminate={numSelected > 0 && numSelected < rowCount}
        checked={rowCount > 0 && numSelected === rowCount}
        onChange={(event) => onSelectAllRows(event.target.checked)}
        inputProps={{ 'aria-label': 'Selecionar todos' }}
        // Mesmo fundo, mesmo problema do texto: marcada ou parcial, a caixa no `primary.main`
        // quase some no escuro.
        sx={{
          '&.Mui-checked, &.MuiCheckbox-indeterminate': (theme) =>
            theme.palette.mode === 'light' ? {} : { color: theme.palette.primary.light },
        }}
      />

      <Typography
        variant="subtitle1"
        sx={{
          ml: 2,
          flexGrow: 1,
          color: (theme) => (theme.palette.mode === 'light' ? 'primary.main' : 'primary.light'),
          ...(dense && {
            ml: 3,
          }),
        }}
      >
        {label ?? `${numSelected} selecionados`}
      </Typography>

      {action && action}
    </Stack>
  );
}
